import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { isMobile } from 'app/helpers/utils';

const PLACEHOLDER_COLOR = '#3637404d';
const BORDER_COLOR = '#c2c3c5';

const FOCUS_OUTLINE_WIDTH = 3;

const Input = styled.input`
  font-family: 'Circular';
  text-align: ${({ textAlign }) => textAlign};
  padding: ${({ padding }) => padding};
  font-size: ${({ size }) => size}px;
  font-weight: 300;
  border-radius: 4px;
  appearance: none;
  ${({ border }) =>
    border
      ? `
    border: 1px solid ${BORDER_COLOR};
    outline:2px solid transparent;
  `
      : `
    border: ${FOCUS_OUTLINE_WIDTH}px solid transparent;
  `};
  width: 100%;

  ::-webkit-input-placeholder {
    /* Chrome/Opera/Safari */
    color: ${PLACEHOLDER_COLOR};
    text-align: center;
  }
  ::-moz-placeholder {
    /* Firefox 19+ */
    color: ${PLACEHOLDER_COLOR};
    text-align: center;
  }
  :-ms-input-placeholder {
    /* IE 10+ */
    color: ${PLACEHOLDER_COLOR};
    text-align: center;
  }
  :-moz-placeholder {
    /* Firefox 18- */
    color: ${PLACEHOLDER_COLOR};
    text-align: center;
  }

  &:focus {
    transition: ease 0.15s;
    outline-width: ${FOCUS_OUTLINE_WIDTH}px;
    outline-style: solid;
    outline-color: #f49f61;
  }
`;

Input.defaultProps = {
  border: false,
  size: 15,
  padding: isMobile ? '13px 30px' : '11px 30px',
  textAlign: 'center',
  placeholder: ''
};

Input.propTypes = {
  size: PropTypes.number.isRequired,
  padding: PropTypes.string.isRequired,
  border: PropTypes.bool.isRequired,
  type: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  ['aria-label']: PropTypes.string.isRequired,
  textAlign: PropTypes.string.isRequired,
};

export default Input;
